/**
 * Created by mnaughton on 10/15/2015.
 */

import BaseListView from "core/views/Field/BaseListView";
import _ from "underscore";
export default BaseListView.extend({
  template: _.template(""),
  itemTemplate: _.template(
    '<label for="<%-id%>" class="radio-button-text blocky"><input type="radio" name="<%-name%>" value="<%-value%>" id="<%-id%>" class="option-radio" <%=selected ? \'checked="checked"\' : \'\'%> /><%-text%></label>'
  ),

  events: {
    "click .radio-button-text": "onChange",
    "click .option-radio": "onChange",
    "keyup .option-radio": "onChange",
  },

  getControlValue: function () {
    var selector = "input[name=" + this.model.id + this.field.id + "]";

    return this.$(selector + ":checked").val();
  },

  setControlValue: function (value) {
    var selector = "input[name=" + this.model.id + this.field.id + "]";

    this.$(selector).each(function () {
      this.checked = this.value == value;
    });
  },

  serializeItems: function (items) {
    return _.map(
      items,
      function (item) {
        return _.extend({}, item, {
          selected: item.value == this.getValue(),
          id: _.uniqueId("radio-field"),
          name: this.model.id + this.field.id,
        });
      },
      this
    );
  },

  insertItem: function (item) {
    this.$el.append(item);
  },
});



//////////////////
// WEBPACK FOOTER
// ./public/js/core/views/Field/edit/RadioButtonView.js
// module id = 843
// module chunks = 1